import { Program, ProgramScheduleType } from 'reducers/programs/types';

export enum PROGRAMS_ACTION_TYPES {
  LOADING = 'LOADING_PROGRAMS',
  LOADED = 'LOADED_PROGRAMS',
}

export type ProgramsActionPayload = {
  id: number;
  error?: string;
};

export type FetchProgramsPayloadType = {
  forceUpdate?: boolean;
  error: string | null;
};

export const fetchPrograms = (payload?: FetchProgramsPayloadType) => ({
  type: PROGRAMS_ACTION_TYPES.LOADING,
  payload,
});

export const fetchProgramsSuccess = (payload: { error: string | null }) => ({
  type: PROGRAMS_ACTION_TYPES.LOADED,
  payload,
});

export enum SCHEDULE_ACTION_TYPES {
  UPDATING = 'UPDATING_SCHEDULE',
  UPDATED = 'UPDATED_SCHEDULE',
}

export type ScheduleActionPayload = {
  programs: Program[];
};

export const updateSchedule = (payload: { error: string | null }) => ({
  type: SCHEDULE_ACTION_TYPES.UPDATING,
  payload,
});

export const updateScheduleSuccess = (payload: { error: string | null }) => ({
  type: SCHEDULE_ACTION_TYPES.UPDATED,
  payload,
});

export enum PROGRAM_SCHEDULE_ACTION_TYPES {
  UPDATING = 'UPDATING_PROGRAM_SCHEDULE',
  UPDATED = 'UPDATED_PROGRAM_SCHEDULE',
  FAILURE = 'FAILED_PROGRAM_SCHEDULE',
}

export type ProgramScheduleActionPayload = {
  programId: number;
  schedule: ProgramScheduleType;
};

export const updateProgramSchedule = (payload: ProgramScheduleActionPayload) => ({
  type: PROGRAM_SCHEDULE_ACTION_TYPES.UPDATING,
  payload,
});

export const updateProgramScheduleSuccess = (payload: { error: string | null }) => ({
  type: PROGRAM_SCHEDULE_ACTION_TYPES.UPDATED,
  payload,
});

export enum PROGRAM_TRACK_ACTION_TYPES {
  CHANGING = 'CHANGING_PROGRAM_TRACK',
  CHANGED = 'CHANGED_PROGRAM_TRACK',
  FAILURE = 'FAILED_PROGRAM_TRACK',
}

export type ChangeProgramTrackPayload = {
  programId: number;
  trackId: number;
};

export const changeProgramTrack = (payload: ChangeProgramTrackPayload) => ({
  type: PROGRAM_TRACK_ACTION_TYPES.CHANGING,
  payload,
});

export const changeProgramTrackSuccess = (payload: { error: string | null }) => ({
  type: PROGRAM_TRACK_ACTION_TYPES.CHANGED,
  payload,
});

export enum RESTART_PROGRAM_ACTION_TYPES {
  RESTARTING = 'RESTARTING_PROGRAM',
  RESTARTED = 'RESTARTED_PROGRAM',
}

export type RestartProgramPayload = {
  programId: number;
};

export const restartProgram = (payload: RestartProgramPayload) => ({
  type: RESTART_PROGRAM_ACTION_TYPES.RESTARTING,
  payload,
});

export const restartProgramSuccess = (payload: { error: string | null }) => ({
  type: RESTART_PROGRAM_ACTION_TYPES.RESTARTED,
  payload,
});
